<script lang="ts">
	import VirtualList from 'svelte-tiny-virtual-list'

	export let itemCount: number
	export let itemHeight: number
</script>

<VirtualList
	height={Math.min(320, itemCount * itemHeight)}
	{itemCount}
	itemSize={itemHeight}
	width="100%"
>
	<!-- TODO: rewrite to Svelte 5 when svelte-tiny-virtual-list is updated -->
	<svelte:fragment slot="item" let:index let:style>
		<slot {index} {style} />
	</svelte:fragment>
</VirtualList>
